'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDayStart = getDayStart;
exports.getDayEnd = getDayEnd;
exports.getEpochDayStart = getEpochDayStart;
exports.getEpochDayEnd = getEpochDayEnd;
exports.formatDate = formatDate;
exports.convertTimeSpanToSQLDays = convertTimeSpanToSQLDays;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDayStart(date) {
  var dayStart = formatDate((0, _moment2.default)(date).startOf('day').toDate(), 'datetime');
  return dayStart;
}

function getDayEnd(date) {
  var dayEnd = formatDate((0, _moment2.default)(date).endOf('day').toDate(), 'datetime');
  return dayEnd;
}

function getEpochDayStart(date) {
  var dayStart = formatDate((0, _moment2.default)(date).startOf('day').toDate(), 'epoch');
  return dayStart;
}

function getEpochDayEnd(date) {
  var dayEnd = formatDate((0, _moment2.default)(date).endOf('day').toDate(), 'epoch');
  return dayEnd;
}

function formatDate(date, formatter) {
  var dateFormat = 'YYYY-MM-DD';
  var dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
  var epochFormat = 'x';

  switch (formatter) {
    case 'date':
      return (0, _moment2.default)(date).format(dateFormat);
    case 'datetime':
      return (0, _moment2.default)(date).format(dateTimeFormat);
    case 'epoch':
      return (0, _moment2.default)(date).format(epochFormat);
    default:
      return (0, _moment2.default)(date).format(dateTimeFormat);
  }
}

function convertTimeSpanToSQLDays() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'days';

  switch (unit) {
    case 'minutes':
      return _moment2.default.duration(value, 'minutes').asDays();
    case 'hours':
      return _moment2.default.duration(value, 'hours').asDays();
    case 'days':
      return _moment2.default.duration(value, 'days').asDays();
    case 'weeks':
      return _moment2.default.duration(value, 'weeks').asDays();
    case 'months':
      return _moment2.default.duration(value, 'months').asDays();
    case 'years':
      return _moment2.default.duration(value, 'years').asDays();
    default:
      console.error('You have provided an invalid unit: ' + unit);
      return null;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/utils/dateUtils.js
// module id = 1637
// module chunks = 0